import { useEffect, useRef, useState } from "react";
import { animate, useInView } from "framer-motion";
import Reveal from "@/components/Reveal";

const stats = [
  { value: 99.9, decimals: 1, suffix: "%", label: "SLA uptime across all queues", testid: "stat-uptime" },
  { value: 24, suffix: "/7", label: "Coverage across every timezone", testid: "stat-coverage" },
  { value: 120, suffix: "+", label: "Trained, brand-certified agents", testid: "stat-agents" },
  { value: 40, suffix: "%", label: "Average client cost reduction", testid: "stat-savings" },
];

const Counter = ({ value, decimals = 0, suffix }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [display, setDisplay] = useState("0");

  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, value, {
      duration: 2,
      ease: [0.16, 1, 0.3, 1],
      onUpdate: (v) => setDisplay(decimals ? v.toFixed(decimals) : String(Math.round(v))),
    });
    return () => controls.stop();
  }, [inView, value, decimals]);

  return (
    <span ref={ref}>
      {display}
      <span className="text-sky-400">{suffix}</span>
    </span>
  );
};

const Stats = () => (
  <section data-testid="stats-section" className="border-y border-white/10 bg-[#0D1424] py-20 md:py-24">
    <div className="mx-auto grid max-w-7xl grid-cols-2 gap-x-6 gap-y-14 px-6 md:grid-cols-4 md:px-12">
      {stats.map((s, i) => (
        <Reveal key={s.testid} delay={i * 0.1} className="border-l border-white/10 pl-6">
          <p data-testid={s.testid} className="font-display text-5xl font-black tracking-tighter md:text-6xl">
            <Counter value={s.value} decimals={s.decimals} suffix={s.suffix} />
          </p>
          <p className="mt-3 text-sm text-slate-400">{s.label}</p>
        </Reveal>
      ))}
    </div>
  </section>
);

export default Stats;
